<div class="c-calculator">
  <div class="c-calculator__actions">
    <div class="title" i18n="@@common.formula">Formula</div>
    <div>
      <button (click)="backspace($event)" [disabled]="!inputs.length">
        <p500-ui-icon [name]="'arrows-select-left'" [size]="'11px'"></p500-ui-icon>
      </button>
      <button (click)="clear($event)" i18n="@@common.clear">Clear</button>
    </div>
  </div>

  <div class="c-calculator__formula">
    <div class="content">
      <span *ngIf="selectedIndex === -1" class="selected"></span>
      <span
        *ngFor="let input of inputs; index as i"
        (click)="selectInput(i)"
        [ngClass]="[selectedIndex === i ? 'selected' : '', input.type !== Types.METRIC ? input.type : '']"
      >
        <ng-container [ngSwitch]="input.type">
          <ng-container *ngSwitchDefault>
            {{ input.value }}
          </ng-container>
          <ng-container *ngSwitchCase="Types.OPERATOR">
            {{ operators[input.value] }}
          </ng-container>
          <ng-container *ngSwitchCase="Types.METRIC">
            <span class="metric mr-0">{{ input.value }}</span>
          </ng-container>
        </ng-container>
      </span>
      <span *ngIf="selectedIndex !== null" (click)="selectLast()" class="continue">...</span>
    </div>
  </div>
  <div class="c-calculator__options">
    <div>
      <button *ngFor="let number of numbers" (click)="addValue(number, Types.NUMBER, $event)" [disabled]="isNumbersDisabled">
        {{ number }}
      </button>
    </div>
    <div>
      <button
        *ngFor="let operator of operators | keyvalue"
        (click)="addValue(operator.key, Types.OPERATOR, $event)"
        [disabled]="isOperatorsDisabled"
      >
        {{ operator.value }}
      </button>
      <button (click)="addValue('(', Types.OPEN_BRACKET, $event)" [disabled]="isOpenBracketDisabled">(</button>
      <button (click)="addValue(')', Types.CLOSE_BRACKET, $event)" [disabled]="isCloseBracketDisabled">)</button>
    </div>
  </div>

  <div class="c-field-value__text text-color--orange mt-10" *ngIf="formulaInvalid" i18n="@@common.formula_invalid">Formula invalid</div>

  <div class="c-calculator__metrics">
    <div class="title" i18n="@@common.base_metrics">Base Metrics</div>
    <div class="list">
      <button
        class="metric mt-4"
        *ngFor="let metric of metrics"
        (click)="addValue(metric.name, Types.METRIC, $event, metric.id)"
        [disabled]="isMetricsDisabled"
      >
        {{ metric.name }}
      </button>
    </div>
  </div>
</div>
